var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingForReturnList), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(item.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("batchCreatedDateFormat")(item.handoverdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("batchCreatedDateFormat")(item.AssignDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.DeliveryUserName))])])
  }), _vm._v(" "), (_vm.pendingForReturnList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "35",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]), _c('br')])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-default tablehead"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Handover Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Asign Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Delivery User Name")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a840256","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/pendingForReturn.vue
// module id = 1059
// module chunks = 1